import { Award } from 'lucide-react';
import { certifications, education } from '@/data';
import { formatEducationRange } from '@/lib/dates';
import { Section } from '@/components/layout/Section';
import { Badge } from '@/components/ui/Badge';
import { Card } from '@/components/ui/Card';
import { Reveal } from '@/components/ui/Reveal';

export function Education() {
  return (
    <Section id="education" title="Education & certifications">
      <div className="space-y-4">
        {education.map((entry, i) => (
          <Reveal key={entry.id} index={i}>
            <Card>
              <div className="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1">
                <h3 className="font-semibold text-foreground">{entry.institution}</h3>
                <span className="text-sm text-muted-foreground">{formatEducationRange(entry)}</span>
              </div>
              <p className="mt-1 text-sm text-muted-foreground">
                {entry.degree} in {entry.field}
                {entry.grade ? ` · ${entry.grade}` : ''} · {entry.location}
              </p>
              {entry.coursework ? (
                <div className="mt-3 flex flex-wrap gap-2">
                  {entry.coursework.map((course) => (
                    <Badge key={course} variant="outline">
                      {course}
                    </Badge>
                  ))}
                </div>
              ) : null}
            </Card>
          </Reveal>
        ))}

        {certifications.map((cert, i) => (
          <Reveal key={cert.id} index={education.length + i}>
            <Card className="flex items-center gap-3">
              <Award className="h-5 w-5 shrink-0 text-primary" aria-hidden />
              <div>
                <h3 className="font-semibold text-foreground">{cert.name}</h3>
                <p className="text-sm text-muted-foreground">{cert.issuer}</p>
              </div>
            </Card>
          </Reveal>
        ))}
      </div>
    </Section>
  );
}
